/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const UpgradeIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="UpgradeIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M7.5 2C7.06653 2 6.6425 2.0425 6.23199 2.12371L6.42606 3.1047C6.773 3.03606 7.13204 3 7.5 3C10.5376 3 13 5.46243 13 8.5C13 11.5376 10.5376 14 7.5 14C7.13204 14 6.773 13.9639 6.42606 13.8953L6.23199 14.8763C6.6425 14.9575 7.06653 15 7.5 15C11.0899 15 14 12.0899 14 8.5C14 4.91015 11.0899 2 7.5 2Z"
                fill="currentColor"
              />
              <path
                d="M3.88815 3.09512C3.17953 3.56953 2.56953 4.17953 2.09512 4.88815L2.92609 5.44447C3.32778 4.84447 3.84447 4.32778 4.44447 3.92609L3.88815 3.09512Z"
                fill="currentColor"
              />
              <path
                d="M1.12371 7.23199C1.0425 7.6425 1 8.06653 1 8.5C1 8.93347 1.0425 9.3575 1.12371 9.76801L2.1047 9.57394C2.03606 9.227 2 8.86796 2 8.5C2 8.13204 2.03606 7.773 2.1047 7.42606L1.12371 7.23199Z"
                fill="currentColor"
              />
              <path
                d="M2.09512 12.1119C2.56953 12.8205 3.17953 13.4305 3.88815 13.9049L4.44447 13.0739C3.84447 12.6722 3.32778 12.1555 2.92609 11.5555L2.09512 12.1119Z"
                fill="currentColor"
              />
              <path
                d="M7 6.70711L5.35355 8.35355L4.64645 7.64645L7.5 4.79289L10.3536 7.64645L9.64645 8.35355L8 6.70711V12H7V6.70711Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

UpgradeIcon.tags = [
  'arrow',
  'circle',
  'upload',
  'update',
  'progress',
  'refresh',
];

UpgradeIcon.category = 'General Icons';

UpgradeIcon.iconSize = 16;
